// TP-Last-Minute enums mirrored from the backend (users.Staff.STAFF_TYPE_CHOICES
// and the LastMinuteListing choices). Kept in one place so the composer + cards
// share exactly the labels the API validates against.

// Staff-role catalog (Staff.STAFF_TYPE_CHOICES) for the staff-listing variant (4f).
export const STAFF_ROLE_CHOICES = [
  { value: "coach", label: "Coach" },
  { value: "ceo", label: "CEO" },
  { value: "technical_director", label: "Technical Director" },
  { value: "sporting_director", label: "Sporting Director" },
  { value: "club_admin", label: "Club Admin" },
  { value: "head_of_scouting", label: "Head of Scouting" },
  { value: "team_manager", label: "Team Manager" },
  { value: "scout", label: "Scout" },
  { value: "medical", label: "Medical" },
  { value: "analysis", label: "Analysis" },
  { value: "operations", label: "Operations" },
  { value: "academy", label: "Academy" },
  { value: "admin", label: "Admin" },
  { value: "other", label: "Other" },
];

export const staffRoleLabel = (value) =>
  STAFF_ROLE_CHOICES.find((r) => r.value === value)?.label || "";

export const VISIBILITY_OPTIONS = [
  { value: "clubs_only", label: "Clubs only", help: "Sporting directors and club scouts." },
  { value: "clubs_agents", label: "Clubs + Agents", help: "Colleagues can bring you opportunities." },
];
